module.exports = __webpack_public_path__ + "static/media/bot.f73ada27.png";